export const postMessageConstants = {
    videoProgress: "VIDEO_PROGRESS",
    percentProgress: "PERCENT_PROGRESS"
}